module.exports = __webpack_public_path__ + "assets/img/306201.71355cf5.svg";